import React from "react";
import { Link } from "react-router-dom";

// En-tête de page de liste : titre, sous-titre optionnel, action principale
// (masquable par rôle via data-priv, comme le composant Page historique).
const ListPageHeader = ({ title, subtitle = null, action = null, children }) => (
  <header className="list-header">
    <div className="list-header__titles">
      <h1 className="list-header__title">{title}</h1>
      {subtitle && <p className="list-header__subtitle">{subtitle}</p>}
    </div>
    <div className="list-header__actions">
      {children}
      {action && (
        <div data-priv={action.dataPriv || undefined}>
          <Link to={action.to} className="btn btn-primary">
            <i className={`fa ${action.icon || "fa-plus"} mr-2`} aria-hidden="true" />
            {action.text}
          </Link>
        </div>
      )}
    </div>
  </header>
);

export default ListPageHeader;
